import { useCommunityJoinSearchParams } from '@/src/features/community/ui/hooks/useCommunityJoinSearchParams'
import { CommunityJoinScreen } from '@/src/features/community/ui/screens/CommunityJoinScreen'

const CommunityJoinRouterPage = () => {
  const { idSlug, course, origin, source } = useCommunityJoinSearchParams()

  if (!idSlug) return null

  return <CommunityJoinScreen idSlug={idSlug} source={source} origin={origin} course={course} />
}

export default CommunityJoinRouterPage
